<script setup lang="ts">
    const { blok } = defineProps<{ blok: ALoginButtonStoryblok }>();
    const loginModalController = useModal();
</script>

<template>
    <div v-editable="blok">
        <template v-if="blok.variant === 'doccheck'">
            <DocCheckLoginButton
                :text="blok.buttonText"
                :size="blok?.size || undefined"
                :retain-size="blok.retainSize"
                :alignment="blok?.alignment || 'center'"
            />
        </template>

        <template v-else>
            <PrimaryButton
                :id="blok._uid"
                native-button
                data-testid="secondary-login-button"
                :button-text="blok.buttonText"
                :size="blok?.size || undefined"
                :retain-size="blok.retainSize"
                :alignment="blok?.alignment || 'center'"
                @click="loginModalController.open"
            >
                <template #customIcon>
                    <img
                        src="~/assets/icons/circle-user-round-white.svg"
                        alt=""
                        aria-hidden="true"
                    />
                </template>
            </PrimaryButton>
            <SharedLoginModal :login-modal-controller="loginModalController" />
        </template>
    </div>
</template>
